<div class="main-content profile-editor-page">
  <div class="container-fluid">
    <section class="profile-editor-page__hero">
      <div class="profile-editor-page__copy">
        <h1>Alta de Perfil</h1>
        <p>Configure el nombre, el sitio y los menús que formarán parte del nuevo perfil.</p>
      </div>

      <div class="profile-editor-page__hero-actions">
        <button type="button" mat-raised-button class="btn profile-editor-page__secondary-btn" (click)="back()">
          Cancelar
        </button>
        <button type="button" mat-raised-button class="btn profile-editor-page__primary-btn" (click)="Guardar()">
          Guardar Perfil
        </button>
      </div>
    </section>

    <div class="row profile-editor-page__layout">
      <div class="col-lg-4 col-md-12">
        <section class="profile-editor-page__card">
          <div class="profile-editor-page__card-header">
            <div class="profile-editor-page__card-title">
              <i class="material-icons">badge</i>
              <span>Datos del Perfil</span>
            </div>
          </div>

          <div class="profile-editor-page__card-body">
            <mat-form-field appearance="outline" class="profile-editor-page__field">
              <mat-label>Nombre del perfil</mat-label>
              <input matInput type="text" name="nombre" [(ngModel)]="nombre" id="nombre" aria-label="Nombre del perfil" />
            </mat-form-field>

            <mat-form-field appearance="outline" class="profile-editor-page__field">
              <mat-label>Sitio</mat-label>
              <mat-select [(ngModel)]="selectedValue" (selectionChange)="capturar($event.value)" id="sitio" name="sitio">
                <mat-option *ngFor="let sitios of sitioperfil" [value]="sitios.nombre">
                  {{ sitios.nombre }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </section>

        <section class="profile-editor-page__card profile-editor-page__card--summary">
          <div class="profile-editor-page__card-header">
            <div class="profile-editor-page__card-title">
              <i class="material-icons">insights</i>
              <span>Resumen</span>
            </div>
          </div>

          <div class="profile-editor-page__card-body profile-editor-page__summary-list">
            <div class="profile-editor-page__summary-item">
              <span>Modo</span>
              <strong>Alta</strong>
            </div>
            <div class="profile-editor-page__summary-item">
              <span>Sitio actual</span>
              <strong>{{ selectedValue || 'Sin seleccionar' }}</strong>
            </div>
            <div class="profile-editor-page__summary-item">
              <span>Menús marcados</span>
              <strong>{{ selectedMenusCount }}</strong>
            </div>
          </div>
        </section>
      </div>

      <div class="col-lg-8 col-md-12">
        <section class="profile-editor-page__card">
          <div class="profile-editor-page__card-header profile-editor-page__card-header--tree">
            <div class="profile-editor-page__card-title">
              <i class="material-icons">account_tree</i>
              <span>Permisos y Menús</span>
            </div>

            <div class="profile-editor-page__tree-meta" *ngIf="selectedValue">
              <span class="profile-editor-page__chip">{{ selectedValue }}</span>
              <span class="profile-editor-page__counter">{{ selectedMenusCount }} seleccionados</span>
            </div>
          </div>

          <div class="profile-editor-page__card-body">
            <ng-container *ngIf="selectedValue; else profileTreePlaceholder">
              <div class="profile-editor-page__tree-wrap" *ngIf="!loadingMenus; else profileTreeLoading">
                <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
                  <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle matTreeNodePadding>
                    <button mat-icon-button disabled></button>
                    <mat-checkbox class="profile-editor-page__tree-check" [checked]="checklistSelection.isSelected(node)"
                      (change)="todoLeafItemSelectionToggle(node)">
                      {{ node.item }}
                    </mat-checkbox>
                  </mat-tree-node>

                  <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding>
                    <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'toggle ' + node.item">
                      <mat-icon class="mat-icon-rtl-mirror">
                        {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
                      </mat-icon>
                    </button>
                    <mat-checkbox class="profile-editor-page__tree-check"
                      [indeterminate]="descendantsPartiallySelected(node)"
                      [checked]="descendantsAllSelected(node)"
                      (change)="todoItemSelectionToggle(node)">
                      {{ node.item }}
                    </mat-checkbox>
                  </mat-tree-node>
                </mat-tree>
              </div>
            </ng-container>

            <ng-template #profileTreeLoading>
              <div class="profile-editor-page__empty-state profile-editor-page__empty-state--loading">
                <i class="material-icons">hourglass_top</i>
                <strong>Cargando menús del sitio...</strong>
              </div>
            </ng-template>

            <ng-template #profileTreePlaceholder>
              <div class="profile-editor-page__empty-state">
                <i class="material-icons">web</i>
                <strong>Selecciona un sitio para comenzar</strong>
                <span>La estructura de menús se cargará automáticamente al elegir el sitio del perfil.</span>
              </div>
            </ng-template>
          </div>
        </section>
      </div>
    </div>
  </div>
</div>
